import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';
import { composeWithDevTools } from 'redux-devtools-extension';


const loggerMiddleware = createLogger();
const configureStore = preloadedState => createStore(
  rootReducer,
  preloadedState,
  // applyMiddleware(thunk)
  composeWithDevTools(
    //   applyMiddleware(...middleware),
    // other store enhancers if any
    applyMiddleware(thunk,loggerMiddleware)
  )


);


export default configureStore;


// WEBPACK FOOTER //
// ./src/store/ConfigureStore.js